import { css } from '@emotion/css';
import { AlignItems, AlignSelf, Color, Display, Font, JustifyContent, SpaceSize, Spacing } from 'src/styles';

export const logoCircle = css`
  ${Display.flex}
  ${AlignItems.center}
  ${JustifyContent.center}
  ${AlignSelf.center}

  width: ${SpaceSize.is64};
  height: ${SpaceSize.is64};
  border-radius: 5rem;
  ${Spacing.mb4}
  ${Spacing.mt16}
`;

export const logo = css`
  ${Font.h6}
`;

export const errorLight = css`
  background-color: ${Color.Red1};
`;

export const successLight = css`
  background-color: ${Color.Green1};
`;

export const errorColor = css`
  color: ${Color.Red6};
`;

export const successColor = css`
  color: ${Color.Green6};
`;
